export const SEND_OTP = 'auth/send-otp';
export const VERIFY_OTP = 'auth/verify-otp';
export const ADD_RESELLER = 'reseller/addReseller';
export const GET_RESELLERS = 'reseller/getResellers';
export const ADD_ORDER = 'orders/addOrder';
export const GET_ORDERS = 'orders/getOrders';
export const GET_DETAIL_ORDERS = 'orders/getDetailOrders';
export const GET_PRODUCTS = 'brandauth/getProducts';